import state from '~store/modules/projects/state'
import actions from '~store/modules/projects/actions'

export default {
  state,
  actions
}
